import jwt from "jsonwebtoken";
import { Cookies } from "react-cookie";
import { store } from "../index";
import moment from "moment";
export const cookie = new Cookies();
export const DomainAPI = process.env.REACT_APP_API_URL;
export const ADMIN_URL =
  process.env.REACT_APP_ADMIN_URL || "http://localhost:3001";
export const socketURL =
  process.env.REACT_APP_SOCKET_URL || "https://dev-socket.masspa.vn";
export const STRIPE_PUBLIC_KEY =
  process.env.STRIPE_PUBLIC_KEY || "pk_test_JAmwfgjBr8LETqW4OdmaF48w00FeNbd0gJ";
export const rateUSD = 23255.814;
export const rowsPerPage = 10;
export const LANGUAGE_SUPPORT = ["japanese", "korean"];
export const Channel = "/internal";
export const Token = "masspaToken";
export const MasspaLanguage = "langCookines";
export const APIKey = "apikey";
export const Authorization = "authorization";
export const SecretApiKey = "ApiKey_MASSPA2018";
export const SecretApiKeyExpires = 1 * 24 * 3600 * 1000;
export const TokenExpires = 7 * 24 * 3600 * 1000;
export const Role = "role";
export const EmployeeRole = "employeeSpa";
export const OwnerRole = "ownerSpa";
export const SuperAdminRole = "admin";
export const EmployeeAdminRole = "employeeAdmin";
export const ApiKeyFirebase = "AIzaSyBkfB0qFjN7oY63aHYTZ5dGLBRrdseZMvA";
export const VNPayConfig = {
  vnp_TmnCode: "Y0LMSN0N",
  vnp_HashSecret: "NQFXWAKSDARDAJRKMSHAUCDWGDEJSILK",
  vnp_Url: "http://sandbox.vnpayment.vn/paymentv2/vpcpay.html",
  vnp_orderType: "250000", // Thanh toán hóa đơn
};
export const ZaloPayConfig = {
  appid: process.env.ZALOPAY_APP_ID || 1006,
  key1: process.env.ZALOPAY_KEY1 || "6mPgTlVr4SG5coAdANhobhRGlwN11Cgi",
  key2: process.env.ZALOPAY_KEY2 || "kq6xJP0cnY7eH8p81gKe48ya2DjgnDo0",
  endpoint:
    process.env.ZALOPAY_ENDPOINT || "https://sandbox.zalopay.com.vn/v001/tpe",
};
export const StripeKey = {
  publicKey: "pk_test_JAmwfgjBr8LETqW4OdmaF48w00FeNbd0gJ",
  privateKey: "sk_test_Jwnjq9xzaFg46DWPUscoDcTm00JzDXLXSk",
};
export const GOOGLE_MAP = {
  API_KEY: "AIzaSyBJd325_tHceTm8qQseqCarnd_XoEW8oAo",
};
export const vapidPushMSGKeys = {
  publicKey:
    "BMJOz1CvJbgD74EY5pjjfiMFf_7jhdRHLeduLUtqrwmiCisJqKlPYmdzQCMj_bZKK6zr9suj5a6B6OIJYpjpx4s",
  privateKey: "PffFeTrgC7Zh7KieDFpOLLojtz7tuxSEbT7F8xEzA4g",
};
export function formatDatetime(milisecond) {
  if (!milisecond) return "";
  let state = store.getState();
  let formatDatetime =
    state.serviceSetting && state.serviceSetting.serviceSetting
      ? state.serviceSetting.serviceSetting.formatDatetime
      : "24h";
  if (formatDatetime === "24h")
    return moment(milisecond).format("DD/MM/YYYY HH:mm");
  else return moment(milisecond).format("DD/MM/YYYY hh:mm A");
}
export function formatDate(milisecond) {
  if (!milisecond) return "";
  return moment(milisecond).format("DD/MM/YYYY");
}
window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
export const colorPrimary = "#292f48";
export const colorDisabled = "rgba(0, 0, 0, 0.6)";
export const colorBackground = "#F4F6F8";
export const colorBackgroundCollapseSelected = "#cecece3d";
export function generateKey() {
  return jwt.sign({ data: Math.random() }, SecretApiKey, {
    expiresIn: SecretApiKeyExpires,
  });
}
export const send_notification_all_users = "allUsers";
export const send_notification_all_services = "allServices";
export const version = "0.4.3";
export const configFirebase = {
  apiKey:
    process.env.ENV === "production"
      ? "AIzaSyDnYkXOLUin4PpTbqY8Ypr5wwlv3N4XQ1I"
      : "AIzaSyCHHXmgshvOS9STBtuXVs75ongRbf-XVpM",
  authDomain:
    process.env.ENV === "production"
      ? "masspa-152306.firebaseapp.com"
      : "masspa-dev.firebaseapp.com",
  databaseURL:
    process.env.ENV === "production"
      ? "https://masspa-152306.firebaseio.com"
      : "https://masspa-dev.firebaseio.com",
  projectId: process.env.ENV === "production" ? "masspa-152306" : "masspa-dev",
  storageBucket:
    process.env.ENV === "production"
      ? "masspa-152306.appspot.com"
      : "masspa-dev.appspot.com",
  messagingSenderId:
    process.env.ENV === "production" ? "318884032685" : "995477577303",
  appId:
    process.env.ENV === "production"
      ? "1:318884032685:android:4bd67de71bdcfb2e"
      : "1:995477577303:web:0e5f4a5ae33eb3d4ce0d12",
};
export const typeNotification = {
  CREATE_BOOKING: "CREATE_BOOKING",
  UPDATE_STATUS_BOOKING_BY_USER: "UPDATE_STATUS_BOOKING_BY_USER",
  UPDATE_STATUS_BOOKING_BY_SERVICE: "UPDATE_STATUS_BOOKING_BY_SERVICE",
  SEND_VOUCHER: "SEND_VOUCHER",
  SEND_MEMBERCARD: "SEND_MEMBERCARD",
  SYSTEM_NOTIFICATION: "SYSTEM_NOTIFICATION",
  SERVICE_ALERT_NOTIFICATION: "SERVICE_ALERT_NOTIFICATION",
};

export function _pick(obj = {}, props = []) {
  const results = {};
  for (let i = 0; i < props.length; i++) {
    if (typeof obj[props[i]] !== "undefined") {
      results[props[i]] = obj[props[i]];
    }
  }

  return results;
}

export function _clear(obj = {}) {
  for (let propName in obj) {
    if (!obj[propName]) {
      delete obj[propName];
    }
  }
}
export const _checkRequired = (object, arr = []) => {
  let result = [];
  object = _pick(object, arr);
  // result = arr.filter(e => !Object.keys(object).find(i => i === e))

  for (let property in object) {
    object[property] = object[property].trim(); // loai bo space
    if (typeof object[property] !== "undefined" && !object[property]) {
      result.push(property);
    }
  }
  return result;
};

export const getBrowserName = (navigator) => {
  let nAgt = navigator.userAgent;
  let browserName = navigator.appName;
  let nameOffset, verOffset;

  // In Opera 15+, the true version is after "OPR/"
  if ((verOffset = nAgt.indexOf("OPR/")) !== -1) {
    browserName = "Opera";
  }
  // In older Opera, the true version is after "Opera" or after "Version"
  else if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
    browserName = "Opera";
  }
  // In MSIE, the true version is after "MSIE" in userAgent
  else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
    browserName = "Microsoft Internet Explorer";
  }
  // In Chrome, the true version is after "Chrome"
  else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
    browserName = "Chrome";
  }
  // In Safari, the true version is after "Safari" or after "Version"
  else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
    browserName = "Safari";
  }
  // In Firefox, the true version is after "Firefox"
  else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
    browserName = "Firefox";
  }
  // In most other browsers, "name/version" is at the end of userAgent
  else if (
    (nameOffset = nAgt.lastIndexOf(" ") + 1) <
    (verOffset = nAgt.lastIndexOf("/"))
  ) {
    browserName = nAgt.substring(nameOffset, verOffset);
  }
  return browserName;
};

export const dayOfWeek = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

//Kiểm tra một chuỗi khi parse có là JSON hay không
export function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function sortObject(object) {
  let sorted = {},
    key,
    a = [];
  for (key in object) {
    if (object.hasOwnProperty(key)) {
      a.push(key);
    }
  }
  a.sort();
  for (key = 0; key < a.length; key++) {
    sorted[a[key]] = object[a[key]];
  }
  return sorted;
}

// Gộp module thành những nhóm liên quan với nhau để hiển thị trên bảng chọn module
export function moduleToGroup(packages) {
  let json = {};
  let keyPackage = Object.keys(packages);
  keyPackage.forEach((key, index) => {
    switch (key) {
      case "dashboard": {
        if (typeof json.dashboard !== "object") json.dashboard = {};
        json.dashboard[key] = packages[key];
        break;
      }
      case "service":
      case "branch":
      case "album":
      case "storage":
      case "sms":
      case "menuService": {
        if (typeof json.mySpa !== "object") json.mySpa = {};
        json.mySpa[key] = packages[key];
        break;
      }
      case "visitor":
      case "post":
      case "contact": {
        if (typeof json.cms !== "object") json.cms = {};
        json.cms[key] = packages[key];
        break;
      }
      case "adminBooking":
      case "mobileBooking": {
        if (typeof json.booking !== "object") json.booking = {};
        json.booking[key] = packages[key];
        break;
      }
      case "adminOrder": {
        if (typeof json.order !== "object") json.order = {};
        json.order[key] = packages[key];
        break;
      }
      case "voucher":
      case "discount":
      case "memberCard": {
        if (typeof json.promotion !== "object") json.promotion = {};
        json.promotion[key] = packages[key];
        break;
      }
      case "customer": {
        if (typeof json.customer !== "object") json.customer = {};
        json.customer[key] = packages[key];
        break;
      }
      case "employeeSystem":
      case "employeeMobile": {
        if (typeof json.employee !== "object") json.employee = {};
        json.employee[key] = packages[key];
        break;
      }
      case "cost": {
        if (typeof json.cost !== "object") json.cost = {};
        json["cost"][key] = packages[key];
        break;
      }
      case "report": {
        if (typeof json.report !== "object") json.report = {};
        json.report[key] = packages[key];
        break;
      }
      case "apiKey": {
        if (typeof json.apiKey !== "object") json.apiKey = {};
        json.apiKey[key] = packages[key];
        break;
      }
      case "pos": {
        if (typeof json.pos !== "object") json.pos = {};
        json.pos[key] = packages[key];
        break;
      }
      default:
        break;
    }
  });
  return json;
}

export const genders = [
  { value: "male", label: "male" },
  { value: "female", label: "female" },
  { value: "other", label: "other" },
];

export const typeContactInfo = [
  {
    type: "name",
    isShow: true,
    isRequired: true,
  },
  {
    type: "phone",
    isShow: true,
    isRequired: true,
  },
  {
    type: "email",
    isShow: true,
    isRequired: false,
  },
  {
    type: "gender",
    isShow: true,
    isRequired: false,
  },
  {
    type: "address",
    isShow: true,
    isRequired: false,
  },
];
export const chartAgeCustomer = {
  "< 20": {
    name: "< 20",
    label: "< 20",
    key: [null, 19],
    value: 0,
    color: "#3fe0ff",
    class: "firstages",
  },
  "20 - 29": {
    name: "20 - 29",
    label: "20 - 29",
    key: [20, 29],
    value: 0,
    color: "#3f98ff",
    class: "secondages",
  },
  "30 - 39": {
    name: "30 - 39",
    label: "30 - 39",
    key: [30, 39],
    value: 0,
    color: "#463fff",
    class: "thirdages",
  },
  "40 - 49": {
    name: "40 - 49",
    label: "40 - 49",
    key: [40, 49],
    value: 0,
    color: "#1053a0",
    class: "fourthages",
  },
  "50 - 60": {
    name: "50 - 60",
    label: "50 - 60",
    key: [50, 60],
    value: 0,
    color: "#97d3ff",
    class: "fifthages",
  },
  "> 60": {
    name: "> 60",
    label: "> 60",
    key: [61, null],
    value: 0,
    color: "#0099ab",
    class: "sixthages",
  },
  other: {
    name: "other",
    label: "other",
    key: "other",
    value: 0,
    color: "#0b3361",
    class: "eighthages",
  },
};
export const chartGenderCustomer = {
  male: {
    name: "male",
    key: "male",
    value: 0,
    class: "male",
    color: "#ff513f",
  },
  female: {
    name: "female",
    key: "female",
    value: 0,
    class: "female",
    color: "#ffbc5b",
  },
  other: {
    name: "other",
    key: "other",
    value: 0,
    class: "othergender",
    color: "#ae76ff",
  },
};
export const filterNotArrived = [
  {
    label: "< 1",
    value: [null, 1],
  },
  {
    label: "< 2",
    value: [null, 2],
  },
  {
    label: "< 3",
    value: [null, 3],
  },
  {
    label: "< 6",
    value: [null, 6],
  },
  {
    label: "< 12",
    value: [null, 12],
  },
  {
    label: "other",
    value: "other",
  },
];

export function parseCountry(lang) {
  if (lang === "vn" || lang === "vi" || lang === "VN-vi" || lang === "VI-vn")
    return "vi";
  else return "en";
}

export function checkStringIsNumber(string) {
  let check = /^\d+$/.test(string);
  return check;
}

export function getHeader(secure = true, token = "") {
  return {
    "Content-Type": "application/json",
    [APIKey]: generateKey(),
    ...(secure ? { [Authorization]: token } : {}),
  };
}

export function isAdmin(role) {
  if (role === "admin" || role === "employeeAdmin") {
    return true;
  } else return false;
}

export function formatAddress(results = {}, location = {}) {
  let data = {};
  data.address = results.formatted_address;
  let address_components = results.address_components;
  data.address_components = address_components;
  address_components.forEach((e) => {
    if (e.types.find((e1) => e1 === "administrative_area_level_2")) {
      data.district = e.short_name;
    } else if (e.types.find((e1) => e1 === "administrative_area_level_1")) {
      data.city = e.short_name;
    } else if (e.types.find((e1) => e1 === "country")) {
      data.country = e.short_name;
    } else if (e.types.find((e1) => e1 === "locality")) {
      data.state = e.short_name;
    }
  });
  data.lat = location.lat;
  data.lng = location.lng;
  return data;
}

export function getNameBranch(code, listBranch = []) {
  let find = listBranch.find((e) => e.branchCode === code);
  if (find) {
    return find.branchName;
  } else return "";
}

export function getOriginalImage(image) {
  return image && image.replace("/thumbnail/", "/");
}

// case packageList have 5 packages
export function sortPackageList(packageList) {
  let packageListSort = [];
  packageList.map((packages) => {
    switch (packages.packageName) {
      case "basic": {
        packageListSort[0] = packages;
        break;
      }
      case "bronze": {
        packageListSort[1] = packages;
        break;
      }
      case "silver": {
        packageListSort[2] = packages;
        break;
      }
      case "gold": {
        packageListSort[3] = packages;
        break;
      }
      case "custom": {
        packageListSort[4] = packages;
        break;
      }
    }
  });
  return packageListSort;
}
